"use client";

import { Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuLayout, NavigationMenuList } from "@/components/ui/navigation-menu";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col sm:flex-row">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-medium)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.75,
    once: true
  });
  const socialIcons = [{
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/rackemjoe/"
  }, {
    icon: Instagram,
    label: "Instagram",
    href: "https://instagram.com"
  }, {
    icon: Youtube,
    label: "YouTube",
    href: "https://youtube.com"
  }];
  return <footer ref={ref} className={`bg-background border-t border-border py-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex-shrink-0">
            <MenuProvider menu_id="6">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="text-center text-foreground/70 text-sm">
            © {new Date().getFullYear()} RackemJoe Live Stream. All rights reserved.
          </div>

          {}
          <div className="flex gap-4 items-center">
            {socialIcons.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab className="text-foreground/70 hover:text-primary transition-all duration-[var(--duration-medium)] hover:drop-shadow-[0_0_8px_hsla(4,95%,52%,0.6)]" aria-label={social.label} data-index={i}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          {}
          <div className="flex-shrink-0">
            <Link to="https://cash.app/$rackemjoelivestream" newTab>
              <Button className="bg-[#00d64b] hover:bg-[#00d64b]/90 text-white font-semibold shadow-md transition-all duration-[var(--duration-medium)] hover:scale-105 active:scale-95 border-none">
                Support the Stream
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}